import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FileX2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const API = window.__BACKEND_URL__;
const money = (n) => Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Admin → Audit Log: permanently deleted Daily Site Invoices (who, when, number, total). Sep 2026.
export const DeletedInvoicesCard = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    axios.get(`${API}/api/daily-invoice-deletions`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }, params: { limit: 100 } })
      .then((r) => setRows(r.data.deletions || []))
      .catch(() => setRows([]));
  }, []);
  return (
    <Card data-testid="deleted-invoices-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2"><FileX2 className="w-4 h-4 text-red-500" /> Deleted invoices</CardTitle>
        <p className="text-xs text-slate-500">Daily Site Invoices that were permanently deleted. Nothing disappears silently — every deletion is recorded here.</p>
      </CardHeader>
      <CardContent>
        {rows === null ? <p className="text-sm text-slate-500">Loading…</p>
          : rows.length === 0 ? <p className="text-sm text-slate-500 py-4 text-center" data-testid="deleted-invoices-empty">No invoices have been deleted.</p>
          : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm" data-testid="deleted-invoices-table">
                <thead><tr className="text-left text-[11px] uppercase tracking-wide text-slate-500">
                  <th className="py-1.5 pr-3">Deleted</th><th className="py-1.5 pr-3">By</th><th className="py-1.5 pr-3">Invoice #</th><th className="py-1.5 pr-3">Service date</th><th className="py-1.5 pr-3">Customer</th><th className="py-1.5 pr-3">Job</th><th className="py-1.5 text-right">Total</th>
                </tr></thead>
                <tbody>
                  {rows.map((d) => (
                    <tr key={d.id} className="border-t border-slate-200 dark:border-slate-700" data-testid={`deleted-invoice-${d.invoice_id || d.id}`}>
                      <td className="py-1.5 pr-3 whitespace-nowrap">{new Date(d.deleted_at).toLocaleString()}</td>
                      <td className="py-1.5 pr-3">{d.deleted_by_name || '—'}</td>
                      <td className="py-1.5 pr-3 font-mono font-semibold">{d.invoice_number}</td>
                      <td className="py-1.5 pr-3">{d.service_date}</td>
                      <td className="py-1.5 pr-3">{d.bill_to_name || '—'}</td>
                      <td className="py-1.5 pr-3">{d.job_title || '—'}</td>
                      <td className="py-1.5 text-right whitespace-nowrap">{d.currency} {money(d.total)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
      </CardContent>
    </Card>
  );
};
